import { IContextualMenuRenderItem } from '@fluentui/react/lib/ContextualMenu';

export function defaultKeytipExecute(el?: HTMLElement, keytipExecute?: (el?: HTMLElement) => void): void {
  el && el.focus();
  keytipExecute && keytipExecute(el);
}

export function menuItemInMenuOnExecute(
  executeTarget: HTMLElement,
  contextualItem: React.RefObject<IContextualMenuRenderItem>
): void {
  executeTarget.focus();
  if (contextualItem.current) {
    contextualItem.current.openSubMenu();
  }
}

export function itemInMenuOnExecute(
  executeTarget: HTMLElement,
  contextualItem: React.RefObject<IContextualMenuRenderItem>,
  keytipExecute: () => void
): void {
  executeTarget.focus();
  if (contextualItem.current) {
    contextualItem.current.dismissMenu(true);
  }
  keytipExecute();
}
